import { httpPost } from './request/index'

// 运营人员考核 -- 列表
export function getUserAssessList (data) {
  return httpPost('/assess/getUserAssessList', data)
}

// 运营人员考核 -- 查看
export function getAssessDetail (data) {
  return httpPost('/assess/getAssessDetail', data)
}

// 运营街道考核\运营小区考核\运营点位考核  -- list
export function getAssessList (data) {
  return httpPost('/assess/getAssessList', data)
}

// 运营街道考核\运营小区考核\运营点位考核  -- view
export function getDetail (data) {
  return httpPost('/assess/getDetail', data)
}

// 首页地图街道排名
export function getStreetRanking (data) {
  return httpPost('/indexPage/getStreetRanking', data)
}
// 首页地图小区排名
export function getEstateSousing (data) {
  return httpPost('/indexPage/getEstateRanking', data)
}
